// extracted by mini-css-extract-plugin
module.exports = {"InfoTile":"InfoTile_InfoTile__PE7_s","paragraph":"InfoTile_paragraph__PY0gH"};